export const CATEGORY_ORDER = ["eval", "note", "measure"] as const;
type KnownCategory = (typeof CATEGORY_ORDER)[number];

export function groupByCategory<T extends { category?: string }>(
  items: T[],
): { label: string; items: T[] }[] {
  const groups: { label: string; items: T[] }[] = [];
  for (const cat of CATEGORY_ORDER) {
    const catItems = items.filter((t) => t.category === cat);
    if (catItems.length > 0) {
      groups.push({ items: catItems, label: cat });
    }
  }
  const uncategorised = items.filter(
    (t) => !t.category || !CATEGORY_ORDER.includes(t.category as KnownCategory),
  );
  if (uncategorised.length > 0) {
    groups.push({ items: uncategorised, label: "other" });
  }
  return groups;
}
